import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";

export const getDashboardData = createAsyncThunk(
  "get/dashboard",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/count",{
        params: payload,
      });
      return response.data; // Ensure to return the data
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    dashboardData: [],
    loading: false,
    error: null, // Add error state to handle rejected cases
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null; // Clear any previous error
      })
      .addCase(getDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardData = action.payload;
      })
      .addCase(getDashboardData.rejected, (state, action) => {
        // Corrected case
        state.loading = false;
        state.error = action.payload || "Something went wrong.";
      });
  },
});

export default dashboardSlice.reducer;
